export default __webpack_public_path__ + "ea48f0134b2e27a4e573505a62ea1eba.svg";